import type { ComponentType } from 'react';

const peopleSearchTitleHandle = {
  pageTitle: 'People Search - DeepSearch',
};

const onboardingPaths = [
  '/people-search',
  '/people-search/step1',
  '/people-search/step2',
  '/people-search/step3',
  '/people-search/step4',
] as const;

const loadOnboarding = async (): Promise<{
  Component: ComponentType;
}> => {
  const { Onboarding } = await import('./Onboarding/Onboarding');
  return { Component: Onboarding };
};

export const peopleSearchOnboardingRoutes = onboardingPaths.map((path) => ({
  handle: peopleSearchTitleHandle,
  path,
  lazy: loadOnboarding,
}));

export const protectedPeopleSearchOnboardingRoutes = [
  {
    handle: peopleSearchTitleHandle,
    path: '/people-search/plan',
    lazy: async () => {
      const { PlanRoute } = await import('./Plan/Plan');
      return { Component: PlanRoute };
    },
  },
];
